import { Service } from "../../module";
import { BufferGeometry, Line, LineBasicMaterial } from "three";
import { roundedRect } from "../../rendering/speechBubble/speechBubbleGeometry";
import { RenderOrder } from "../../rendering/RenderOrder";
import { VrHudMessage } from "../../../messages/xr";
import { configurePostprocessingOverlay } from "../../rendering/postprocessing/PostprocessingOverlay";
// A service to handle VR HUD related functionalities in training modules
export class TrainingVrHudService extends Service {
    constructor(vrHud) {
        super(vrHud.connection);
        // Store body markers by their IDs
        this.bodyMarker = new Map();
        this.vrHud = vrHud;
        this.initTrainingHud();
    }
    initTrainingHud() {
        // Example: Create a training avatar image sprite at z=0
        this.vrHud.createImageSprite("trainingAvatar", "img/training/TrainingAvatar.png", [0.35, 0.35], [0, 0.25, 0]);
        this.vrHud.createImageSprite("thumbsUp", "img/training/thumbs-up-solid.png", [0.15, 0.15], [0, 0, 0]).visible = false;
    }
    updateDisplayedTask(message) {
        this.vrHud.handleVrHudMessage(new VrHudMessage(message, "currentTask"));
    }
    createBodyMarker(id, position, size, color) {
        const shape = roundedRect(-size[0] / 2, -size[1] / 2, size[0] / 2, size[1] / 2, 0.005);
        const points = shape.getPoints();
        const geometry = new BufferGeometry().setFromPoints(points);
        const marker = new Line(geometry, new LineBasicMaterial({ color: color, depthTest: false, transparent: true, opacity: 0.5 }));
        configurePostprocessingOverlay(marker);
        marker.position.set(position[0] + size[0] / 4, position[1] + size[1] / 4, position[2]);
        marker.renderOrder = RenderOrder.HUD_MARKER_ELEMENTS;
        this.bodyMarker.set(id, marker);
        this.vrHud.contents.set(id, marker);
        this.vrHud.add(marker);
        return marker;
    }
    changeBodyMarkerColor(id, color, flash = true) {
        const marker = this.bodyMarker.get(id);
        if (marker !== undefined && marker.material instanceof LineBasicMaterial) {
            marker.material.color.set(color);
            marker.material.needsUpdate = true;
        }
        if (flash) {
            this.vrHud.flashElement(id, "yellow", 500, 5);
        }
    }
    setVisibility(visible) {
        this.vrHud.visible = visible;
    }
    getVisibility() {
        return this.vrHud.visible;
    }
    setContentVisibility(name, visible) {
        const element = this.vrHud.contents.get(name);
        if (element !== undefined) {
            element.visible = visible;
        }
    }
}
